import React from "react";
import { Stack, Typography } from "@mui/material";

const EmailInfoPopupRow = ({
  label,
  children,
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center">
      <Typography
        variant="subtitle2"
        color={(theme) => theme.palette.text.secondary}
      >
        {label}:&nbsp;
      </Typography>
      {children}
    </Stack>
  );
};

export default EmailInfoPopupRow;